import React from "react";

function Intro() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <h1 className="page-title">Podcast</h1>
          <p className="page-description">Lets Talk Sustainability</p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
